import { AfterViewInit, Component, inject, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { take } from 'rxjs/operators';
import { AppTranslation } from './app-app-translation';
import { AppAngularBridge } from './app-bridge';
import { DxButtonModule } from 'devextreme-angular/ui/button';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-error-page',
  imports: [DxButtonModule, TranslateModule],
  templateUrl: './error-page.component.html',
})
export class ErrorPageComponent implements OnInit, AfterViewInit {
  private router = inject(Router);

  public ngOnInit() {
    AppTranslation.setAppTranslationUserPreferredLang().pipe(take(1)).subscribe();
  }

  public ngAfterViewInit() {
    setTimeout(() => {
      AppAngularBridge.webReady();
    }, 0);
  }

  public reload() {
    this.router.navigate(['/']);
  }
}
